import { connect } from 'react-redux';
import * as R from 'ramda';
import SequenceStep3 from './SequenceStep3';
import { getStoreValueByProp } from '../../store/sequencingWizardSlice';

const mapState = R.applySpec({
  loading: getStoreValueByProp(['locationsLoading']),
});

export default connect(mapState, null)(SequenceStep3);
